import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useDashboardPhaseCountAndAmounts } from '@/hooks/api/2070_dashboard_phase_count_and_amounts';
import { MotionDiv } from '@/components/element/MotionDiv';
import { useDashboardSearchCondition } from '@/providers/DashboardSearchConditionProvider';

export const PhaseCountAndAmounts = () => {
  const { _w_ } = useCurrentWorkspace();
  const { salesOrdersDashboardSearchCondition: searchCondition, setSalesOrdersDashboardSearchCondition: setSearchCondition } = useDashboardSearchCondition();
  const { data } = useDashboardPhaseCountAndAmounts({ ...searchCondition, identifier: _w_!.identifier });

  if (data == null) return <></>;

  return (
    <MotionDiv className="row">
      {data.map((d, i) => (
        <div key={`pcaa-${i}`} className="col-lg-2 col-md-4 col-sm-6">
          <div className="card mb-md-3 mb-sm-3 mb-4">
            <div className="card-body p-3">
              <p className="text-xs mb-0 font-weight-bold">{d.name}</p>
              <h5 className="font-weight-bolder mb-0">{d.count}</h5>
              <p className="text-xs mb-0">¥{d.amount.toLocaleString()}</p>
            </div>
          </div>
        </div>
      ))}
    </MotionDiv>
  );
};
